import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component BulbIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <BulbIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <BulbIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const BulbIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      data-testid="BulbIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M9.132 13.6a.533.533 0 1 1 0 1.067H6.865a.533.533 0 0 1 0-1.067zM10.132 11.667a.533.533 0 0 1 0 1.066H5.865a.533.533 0 0 1 0-1.066zM7.999 1.333a4.667 4.667 0 0 1 2.666 8.495v.839H9.332v-.521c0-.663.421-1.236.91-1.682a3.333 3.333 0 1 0-4.488 0c.49.446.911 1.02.911 1.682v.52H5.332v-.838a4.667 4.667 0 0 1 2.667-8.495" />
    </svg>
  )
);
BulbIcon.displayName = "BulbIcon";
export default BulbIcon;
